import React, { useState } from "react";
import "./CreateNode.scss";

interface CreateNodeProps {
  onDrag: (et: React.DragEvent<HTMLDivElement>, elm: string) => void;
  onDragStart: (et: React.DragEvent<HTMLDivElement>, elm: string) => void;
  openTypes: boolean;
  toggleOpenTypes: () => void;
}

const CreateNode: React.FC<CreateNodeProps> = ({
  onDrag,
  onDragStart,
  openTypes,
  toggleOpenTypes,
}) => {
  return (
    <div className="create-stage-container flex-column gap-16 align-items-center">
      <div className="create-box" onClick={toggleOpenTypes}>
        <div
          style={{
            backgroundImage:
              "url(https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250225082156-plus.svg)",
            height: "24px",
            width: "24px",
          }}
        />
      </div>
      {openTypes && (
        <div className="node-types-container flex-column px-10 py-12">
          <div
            className="flex-row gap-8 align-items-center p-8 node"
            onDrag={(e) => onDrag(e, "normal")}
            draggable
            id="create-elm-normal"
            onDragStart={(e) => onDragStart(e, "normal")}
          >
            <img
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250312081351-cuida_subtask-outline.svg"
              width={12}
              height={12}
              alt="normal"
            />
            <p className="xetgo-font-tag" style={{ color: "#333333B8" }}>
              Task
            </p>
          </div>
          <div
            className="flex-row gap-8 align-items-center p-8 node"
            onDrag={(e) => onDrag(e, "end")}
            draggable
            id="create-elm-end"
            onDragStart={(e) => onDragStart(e, "end")}
          >
            <img
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250312081351-material-symbols-light_line-end-circle.svg"
              width={12}
              height={12}
              alt="end"
            />
            <p className="xetgo-font-tag" style={{ color: "#333333B8" }}>
              End Task
            </p>
          </div>
          <div
            className="flex-row gap-8 align-items-center p-8 node"
            onDrag={(e) => onDrag(e, "decision")}
            draggable
            id="create-elm-decision"
            onDragStart={(e) => onDragStart(e, "decision")}
          >
            <img
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250312081351-Frame+1321315749.svg"
              width={12}
              height={12}
              alt="decision"
            />
            <p className="xetgo-font-tag" style={{ color: "#333333B8" }}>
              Decision Node
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateNode;
